import {Assignment} from "@mui/icons-material";
import {Button, Paper} from "@mui/material";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {useNavigate} from "react-router";


export const ContaContabilIndexPage: React.FC = () => {
    const navigate = useNavigate()

    return (<DefaultContainer titulo={'Contratos'}
                              size={'medium'}
                              component={Paper}>
            <Button endIcon={<Assignment/>}
                    variant="outlined"
                    color="primary"
                    onClick={() => navigate('/contaContabil/consulta')}
                    fullWidth>
                Consultar Contas Contábeis
            </Button>
            <Button endIcon={<Assignment/>}
                    variant="outlined"
                    color="primary"
                    onClick={() => navigate('/contaContabil/cadastro')}
                    fullWidth>
                Cadastrar Conta Contábil
            </Button>
        </DefaultContainer>
    );
}